import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

export const SuggestedSearch = styled(Flex)`
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: ${({ theme }) => theme.spacing(2)} 0;
`;

export const CollectionContainer = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(1)};
    margin-right: ${theme.spacing(1)};
    margin-left: ${theme.spacing(1)};
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }

    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(2)};
      margin-right: ${theme.spacing(1)};
      margin-left: ${theme.spacing(1)};
    }
  `}
`;

export const StyledLink = styled(LinkWithLocale)`
  text-underline-offset: 5px;
  ${({ theme }) => css`
    margin-left: ${theme.spacing(0.5)};
    transition: ${theme.transitions.create('color')};
    text-decoration-color: ${theme.colors.primary};
  `}

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
